import React from "react";
import PropsTypes from "prop-types";
import _ from "lodash";
import axios from "axios";
import { getSign } from "virsical-sign";
import imageMarkerPng from "./assets/imgs/imageMarker.png";
import startPng from "./assets/imgs/start.png";
import endPng from "./assets/imgs/end.png";
import navigationICONPng from "./assets/imgs/navigationICON.png";

let timer = null;

const path = {
    "/virsical-map": "virsical-map",
    "/vsk/virsical-map": "vsk/virsical-map"
};

const urlSign = (newUrl, token, SING_KEY) => {
    // 开始签名
    //  取第二个 '/' 前的字符
    let restfulPath = newUrl.substring(0, newUrl.indexOf("/", 1));
    if(newUrl && newUrl.includes('/vsk/')){
        restfulPath = newUrl.substring(0, newUrl.indexOf('/', newUrl.indexOf('/', 1) + 1));
    }
    let signPath = newUrl;
    // 判断url中如果包含restful前缀，需要清除，签名用
    if (Object.prototype.hasOwnProperty.call(path, restfulPath)) {
        signPath = newUrl.replace(restfulPath, "");
    }

    // 生成签名用的时间戳
    const timestamp = new Date().getTime();

    // 获取token
    const relToken = token.substring(7) || '';
    // 地图服务只签名get请求
    return {
        'vsk-signature': getSign(signPath, relToken, SING_KEY, timestamp),
        test: "test",
        'vsk-timestamp': timestamp,
    };
};

const customGet = (
    url,
    signatureKey,
    restfulSignature,
    token
) => {
    let headers = { Authorization: token, 'vsk-auth': token };
    if (signatureKey && restfulSignature) {
        headers = { ...headers, ...urlSign(url, token, signatureKey) };
    }

    return axios.get(url, { headers: { ...headers } });
};

const DEFAULT_WIDTH = 1920; // 缺省宽度
const DEFAULT_HEIGHT = 1080; // 缺省高度
const DEFAULT_BACKGROUND = "#ddd"; // 缺省背景色

class ChaunveMap extends React.PureComponent {
    center = {};

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            mapInfo: {}, // 地图设置信息
            mapElements: [],
            markers: [], // 所有标记的集合
            showToolTip: false,
            selectedEle: [], // 选中的元素集合，创互的元素节点
            //  init 未开始； doing 进行中； pause 暂停，
            navState: 'init',
            multipleType: '',
            locationSvgMark: {},
            mapColorSet: {},
        };
    }

    UNSAFE_componentWillMount() {
        // this.center = {
        //     stationCenterX: (Number(this.props.componentWidth || 1920)) / 2,
        //     stationCenterY: (Number(this.props.componentHeight || 1080)) / 2
        // };
    }

    componentDidMount() {
        const { mapId } = this.props;
        window.GIM.OverrideURL = true;
        window.GIM.SURL = startPng;
        window.GIM.EURL = endPng;
        window.GIM.MURL = imageMarkerPng
        window.GIM.NURL = navigationICONPng;

        if(mapId){
            this.loadMapData(mapId, false);
        }
        // if (_.isEmpty(window.ChaunveMap)) {
        //   this.init();
        // }
    }

    UNSAFE_componentWillReceiveProps(np) {
        const {
            mapId,
            multiple,
            opacity,
            reloadMap,
            reSetMap,
            selectableType,
            clearSelectFlag,
            reSetClearFinish,
            showStateIds,
            markId
        } = this.props;
        //  const { showPath, markId, mapZoom, mapMove } = np;
        // 切换地图id时重新加载地图
        if (np.mapId && mapId !== np.mapId) {
            this.disposePage().then(()=>{
                this.loadMapData(np.mapId, false);
            });
            return;
        }
        // 设置透明度
        if (opacity !== np.opacity) {
            // window.console.log(this.map, np.multiple, '11111');
            this.map.opacity = np.opacity;
            //   this.map.reset();
        }
        // 切换单选多选模式时，清空已选中项
        if (this.map && multiple !== np.multiple) {
            //  window.console.log(this.map, np.multiple, '11111');
            this.map.cleanSelectUnit3D([]);
            this.map.multipleSelectionMode = np.multiple;
            //   this.map.reset();
        }

        // 切换素材类型时，清空已选中项
        // if (selectableType !== np.selectableType) {
        //   //  window.console.log(this.map, np.multiple, '11111');
        //   this.map.cleanSelectUnit3D([]);
        //   this.map.multipleSelectionMode = np.multiple;
        //   //   this.map.reset();
        // }

        // 当调用重新加载地图时，reloadMap传true
        if (this.map && np.reloadMap && reloadMap !== np.reloadMap) {
            this.map.cleanSelectUnit3D();
            this.setState({selectedEle: [] });
            this.reloadElements();
            return;
        }

        // 地图素材变化需要重新渲染地图， reSetMap传true
        if (np.reSetMap && reSetMap !== np.reSetMap) {
            if (this.map) {
                this.disposePage().then(()=>{
                    this.map = null;
                    this.loadMapData(mapId, true);
                });
            } else {
                this.loadMapData(mapId, true);
            }

            return;
        }

        // 当需要清除选中状态标记
        if (this.map && np.clearSelectFlag && clearSelectFlag !== np.clearSelectFlag) {
            this.map.cleanSelectUnit3D([]);
            reSetClearFinish();
            this.setState({multipleType: ''});
            return;
        }

        // 当用户设置的颜色和文字变化是更新
        if (np.showStateIds && _.differenceWith(showStateIds, np.showStateIds, _.isEqual).length !== 0 && this.map) {
            this.renderByState(np.showStateIds)
        }

        // 当用户设置的标记变化时更新
        if (np.markId && np.markId !== markId && this.map) {
            // console.log('marrkId 更新')
            this.setMark(np.markId)
        }
    }

    componentWillUnmount() {
        // if (timer) {
        //   clearTimeout(timer);
        // }
        // this.disposePage();
        // this.map = null;
        // console.log('componentWillUnmount')
    }

    // 初始化加载地图所用的数据
    loadMapData = (mapId, isReSetMap) => {
        const {
            token,
            signatureKey,
            restfulSignature,
            reSetMapFinish,
            defaultPath
        } = this.props;

        customGet(
            `/${defaultPath}virsical-map/map/${mapId}`,
            signatureKey,
            restfulSignature,
            token
        )
            .then(({ data }) => {
                if (isReSetMap) {
                    reSetMapFinish();
                }
                if (data && data.code === 0) {
                    // 地图数据获取，根据类型获取地图
                    if (data.data.mapType === 1) {
                        // window.console.log(data);
                        let objIcon = {};
                        let objColor = {};
                        if (data.data.icon) {
                            objIcon = JSON.parse(data.data.icon);
                        }
                        if (data.data.colors) {
                            objColor = JSON.parse(data.data.colors);
                        }

                        // 创互地图
                        this.setState({ mapInfo: data.data, locationSvgMark: objIcon, mapColorSet: objColor });
                        if (_.isEmpty(this.map)) {
                            this.init(data.data);
                        }
                    }
                }
            })
            .catch((err) => {
                console.error("地图获取失败", err);
            });
        // 加载地图上所有元素信息和元素位置信息
        customGet(
            `/${defaultPath}virsical-map/map-element/list?mapId=${mapId}`,
            signatureKey,
            restfulSignature,
            token
        )
            .then(({ data }) => {
                if (data && data.code === 0) {
                    this.setState({ mapElements: data.data || [] });
                }
            })
            .catch(() => {
                console.error("地图元素获取失败");
            });
    };

    // 更新地图上的元素
    reloadElements = () => {
        const {
            mapId,
            token,
            signatureKey,
            restfulSignature,
            reloadFinish,
            defaultPath,
        } = this.props;
        // 加载地图上所有元素信息和元素位置信息
        customGet(
            `/${defaultPath}virsical-map/map-element/list?mapId=${mapId}`,
            signatureKey,
            restfulSignature,
            token
        )
            .then(({ data }) => {
                reloadFinish();
                if (data && data.code === 0) {
                    this.setState({ mapElements: data.data || [] });
                    this.showData();
                }
            })
            .catch(() => {
                console.error("地图元素获取失败");
            });
    };

    init = (cmapData) => {
        // this.setState({isLoading: true});
        // timer = setTimeout(() => {
        //     const {isLoading} = this.state;
        //     if (isLoading) {
        //       //  message.error('地图加载失败，请检查网络和楼宇ID配置是否正确！', 3);
        //         this.setState({isLoading: false});
        //     }
        // }, 2000);
        const {
            componentWidth,
            componentHeight,
            multiple,
            opacity,
            themeID,
            background,
            preCreation,
            labelScale,
            showLabelType,
            logoFiled,
            focusSelect,
            isJavaServer,
            defaultCenterPoint,
            zoomLevel,
            labelViewModel,
            maxCameraRadius,
            selectedColor,
            polarAngle,
            enabledControl,
            edgeColor,
            wapperId
        } = this.props;

        const container = document.getElementById(wapperId); //地图显示容器
        if (!container) {
            return;
        }

        const params = {
            debug: false, //是否开启debug模式 布尔值
            initCompleted: this.finishLoad, //初始化完成之后的调用函数
            onSelected: this.onSelected, //当区块被选中时触发
            container: container, //包装的 div
            themeID: themeID, //主题文件夹编号,
            backgroundColor: background, //地图背景颜色
            compassOffset: [10, 10, 0, 0], //指南针的位置和角度
            showLabelType: showLabelType, //默认显示店铺号，可以选
            crossBuild: false, //是否跨建筑
            labelScale: labelScale, //文本缩放值
            groundLayer: false, //是否设置地图底图 布尔值,
            labelViewModel: labelViewModel,
            bgisSvg: true, //底图是否是svg  布尔值
            buildingID: cmapData.cmapBuildingId || "", //初始化显示楼宇  必填
            initFloorID: cmapData.cmapFloorId || "", //初始化显示楼层  必填
            initFloorCorrect: false, // false时initFloorID传入错误楼层或者不传，即不渲染地图
            projectID: cmapData.cmapProjectId || "", //项目 ID 必填
            cloudID: cmapData.cmapCloudId, //项目云ID 暂时不需要配置
            preCreation: preCreation, //是否后台静默渲染 默认为 true
            accessToken: cmapData.cmapAccesstoken || "", //key 暂时不需要配置
            server: cmapData.cmapServer || "",
            isJavaServer: isJavaServer, //是否使用java接口
            logoFiled: logoFiled, //显示的公共设施使用后台的哪个 字段 DownLogo,Logo,UpLogo
            edgeColor: this.colorToNum(edgeColor), // 描边的颜色
            focusSelect: focusSelect, // 选中是否自动居中
            enabledControl: enabledControl, // 是否启用手势操作
            onHover: this.onHover
        };


        this.map = new window.GIM.Map3D(params); // 初始化地图
        this.map.showCompass(false);
        this.map.maxCameraRadius = maxCameraRadius;
        this.map.minCameraRadius = 1000;
        this.map.cameraRadius = 7000;
        if (cmapData.cmapBuildingId) {
            this.map.defaultCenterPoint = {
                x: defaultCenterPoint,
                y: -defaultCenterPoint,
            };
        }
        // 文本显示层级 数值越大 越容易显示
        window.GIM.SHOW_SPRITE_LENGTH = 100000;
        // /* 公共设施显示层级 */
        // window.GIM.SHOW_Facility_LENGTH = 1;
        this.map.setPolarAngle(polarAngle);
        this.map.zoomLevel(zoomLevel);
        this.map.selectedColor = this.colorToNum(selectedColor);
        this.map.multipleSelectionMode = multiple;
        this.map.opacity = opacity;
        window.ChaunveMap = this.map; // 初始化地图
        window.addEventListener("resize", () => {
            if (this.map) {
                //重新给地图设置最新的宽高
                this.map.setSize(componentWidth, componentHeight);
            }
        });
        // 这里需要重新设置地图的宽高，否则地图上的工位实际位置与渲染的会有偏差
        setTimeout(() => {
            this.map.setSize(componentWidth, componentHeight);
        }, 1000);
        this.map.markerScale = 1.5; //设置地图上标记缩放比例
        this.map.facilityScale = 1.5;
    };

    cleanSelectionMode = () => {
        if (this.map) {
            this.map.cleanSelectUnit3D([]);
        }
    };

    // 清除选中的元素集合
    cleanSelectId = (ids = []) => {
        this.map && this.map.cleanSelectUnit3D(ids);
    };

    // 选中多个元素
    setSelectEle = (ids = []) => {
        if (!this.map) {
            return;
        }
        ids.forEach((id) => {
            this.map.selectByID(id);
        });
    };

    multipleSelectionMode = (value) => {
        if (this.map) {
            this.map.multipleSelectionMode = Boolean(value);
            this.cleanSelectionMode();
        }
    };

    clean = (pushPointId) => {
        if (this.map && pushPointId.length > 0) {
            this.map.cleanSelectUnit3D(pushPointId);
        }
    };

    // 切换楼宇销毁并重建地图对象
    dispose = (mapBuildingId) => {
        this.disposePage();
        // 根据楼宇id重新初始化地图对象
        //  this.init(mapBuildingId);
    };

    // 离开页面销毁地图对象
    disposePage = async () => {
        clearTimeout(timer);
        if (this.map) {
            this.map.dispose();
        }
        // 清除地图Canvas对象
        await new Promise((resolve) => {
            const mapDom = document.getElementById("mapContainer");
            for (
                let index = 0;
                index < document.getElementById("mapContainer").children.length;
                index++
            ) {
                setTimeout(() => {
                    mapDom.removeChild(mapDom.firstChild);
                }, 0);
            }
            resolve();
        });
    };

    onSelected = (data = {}, parms = null, selectedList) => {
        const {
            multiple,
            onClick,
            showStateIds,
            onSelected,
            clickableElement,
            mapSpaceJump,
            reSetMapId,
            onClickError,
        } = this.props;
        const { mapElements, selectedEle, multipleType, mapColorSet } = this.state;
        // console.log('onSelect', data, selectedList)
        // 选择不可点击的元素，清空选中图标和回复本来的颜色
        // 选择不可点击的元素，但元素设定了自定义的颜色，值清空选中图标
        const isClick = clickableElement && clickableElement.length >= 0 && !clickableElement.includes(data.nodeId)
        const ele = showStateIds && showStateIds.find(d => d.id === data.nodeId)
        if (isClick) {
            this.map && this.map.cleanSelectUnit3D([data.nodeId]);
            const model =  this.map && this.map.getModelByID(data.nodeId)
            if (model && !ele) {
                model.recover();
            } else if (ele) {
                if(ele.color){
                    let fillColor = '';
                    // 20210616 新增设置素材状态颜色和透明度，objectColor如果不为空，并且以#开头，则为设置的素材颜色；不为空并且不已#开头，根据objectColor的内容去查找素材状态颜色；否则为默认颜色
                    if (ele.color.startsWith('#')) {
                        fillColor = ele.color;
                    } else if (ele.color === 'free') {
                        fillColor = mapColorSet?.freeRgb || '#69E5A5';
                    } else if (ele.color === 'busy') {
                        fillColor = mapColorSet?.busyRgb || '#FD7C7C';
                    } else if (ele.color === 'disabled') {
                        fillColor = mapColorSet?.disabledRgb || '#D1D8DF';
                    }
                    model.setColor(fillColor)
                }
            }
            onClickError(data.nodeId);
            return;
        }

        if( mapSpaceJump ){
            const selectEle = mapElements.find(e => e.mapElementId === data.nodeId) || { mapElementId: data.nodeId };
            Object.assign(selectEle, { nodeId: data.nodeId})
            window.console.log(selectEle);
            try {
                const mapObj = JSON.parse(selectEle.extend);
                reSetMapId(mapObj);
            } catch (e) {
                window.console.log(e);
            }

            onClickError(data.nodeId);
            return;
        }

        if (multiple) {
            const selectEle = mapElements.find(d => d.mapElementId === data.nodeId);
            if(selectEle && !multipleType){
                this.setState({multipleType: selectEle.svgTypeCode});
            }

            if(selectEle && multipleType && selectEle.svgTypeCode !== multipleType && this.map) {
                this.map.cleanSelectUnit3D([data.nodeId]);
                onClickError(data.nodeId);
                return;
            }

            if(selectedList.length === 0){
                this.setState({multipleType: ''})
            }

            const list = selectedList.map((select) => {
                const obj = mapElements.find(d => d.mapElementId === select.nodeId) || { mapElementId: select.nodeId };
                return {...obj, nodeId: select.nodeId }
            })

            onSelected(list);
            this.setState({ selectedEle: selectedList })
        } else {
            // 单选事件回调
            // 如果选中上一次选中的节点，则取消选中；如果选中其他节点则选中
            const isCancel = selectedEle[0] && selectedEle[0].nodeId === data.nodeId
            if(isCancel && this.map) {
                this.map.cleanSelectUnit3D();
                this.setState({selectedEle: [] })
            } else {
                this.setState({selectedEle: selectedList })
            }
            const ele = mapElements.find(e => e.mapElementId === data.nodeId) || { mapElementId: data.nodeId }
            Object.assign(ele, { nodeId: data.nodeId})
            // 第二个参数为是否取消选中， true 为取消选中，false为选中
            onClick(ele, isCancel);
            this.setState({ showToolTip: true })
        }
    };

    onHover = (data) => {
        // 因为悬浮事件，地图并没有居中，故不适合用作气泡框
        const { onHover } = this.props
        onHover(data)
    }

    // 初始化完成调用
    finishLoad = (floorData) => {
        const { initCompleted } = this.props;
        if (typeof initCompleted === "function") {
            initCompleted(floorData);
            if (this.map) {
                const { componentWidth, componentHeight } = this.props;
                //重新给地图设置最新的宽高
                this.map.setSize(componentWidth, componentHeight);
            }
        }
        this.showData()
    };

    showData = () => {
        if (this.map) {
            // mapElements 所有绑定的素材
            const { noName, markId } = this.props;
            const { mapElements, mapColorSet } = this.state;
            if (mapElements && mapElements.length > 0) {
                // window.console.log("showData mapElements", mapElements);
                mapElements.forEach((element) => {
                    if (this.map.getModelByID(String(element.mapElementId))) {
                        if (element.objectColor) {
                            let fillColor = ''
                            // 20210616 新增设置素材状态颜色和透明度，objectColor如果不为空，并且以#开头，则为设置的素材颜色；不为空并且不已#开头，根据objectColor的内容去查找素材状态颜色；否则为默认颜色
                            if (element.objectColor.startsWith('#')) {
                                fillColor = element.objectColor;
                            } else if (element.objectColor === 'free') {
                                fillColor = mapColorSet?.freeRgb || '#69E5A5';
                            } else if (element.objectColor === 'busy') {
                                fillColor = mapColorSet?.busyRgb || '#FD7C7C';
                            } else if (element.objectColor === 'disabled') {
                                fillColor = mapColorSet?.disabledRgb || '#D1D8DF';
                            }

                            this.map
                                .getModelByID(String(element.mapElementId))
                                .setColor(fillColor);
                        } else {
                            this.map.getModelByID(String(element.mapElementId)).recover();
                        }
                        if (element.objectName && !noName) {
                            this.map
                                .getModelByID(String(element.mapElementId))
                                .setText(element.objectName);
                        } else {
                            this.map.getModelByID(String(element.mapElementId)).setText("");
                        }
                    }
                    // console.log('组件本身属性设置完毕')
                    this.renderElements(element);
                });
                const { showStateIds } = this.props

                this.renderByState(showStateIds)
                this.setMark(markId)
            }
        }
    };

    // 控制地图上元素集合的渲染
    renderElements = (element = {}) => {
        const {
            visibleElement,
            visibleType,
            visibleState,
            showStateIds,
        } = this.props;
        // 1、根据需求，判断元素在地图上是否需要显示
        // 判断元素的id是否可以显示
        // console.log('renderElements', visibleElement, element)
        if (
            Array.isArray(visibleElement) &&
            (visibleElement.length === 0 ||
                (visibleElement.length > 0 &&
                    !visibleElement.includes(element.mapElementId)))
        ) {
            const model = this.map.getModelByID(element.mapElementId);
            if (model) {
                model.visible = false;
            }
        }
        // 判断元素的类型（如：工位，会议室等）
        if (
            Array.isArray(visibleType) &&
            (visibleType.length === 0 ||
                (visibleType.length > 0 && !visibleType.includes(element.svgTypeCode)))
        ) {
            const model = this.map.getModelByID(element.mapElementId);
            if (model) {
                model.visible = false;
            }
        }
        // 判断元素的状态（如：空闲，占用等）
        if (
            Array.isArray(visibleState) &&
            (visibleState.length === 0 ||
                (visibleState.length > 0 &&
                    !visibleState.includes(element.objectSvgStateCode)))
        ) {
            const model = this.map.getModelByID(element.mapElementId);
            if (model) {
                model.visible = false;
            }
        }

        // 判断元素是否显示设定颜色（地图上是否需要显示)
        if (
            Array.isArray(showStateIds) &&
            (showStateIds.length === 0 ||
                (showStateIds.length > 0 &&
                    !showStateIds.includes(element.mapElementId)))
        ) {
            const model = this.map.getModelByID(element.mapElementId);
            if (model) {
                model.recover();
            }
        }
    };

    // 渲染用户设置的颜色和文字
    renderByState = (showStateIds) => {
        const { noName } = this.props;
        const { selectedEle, mapColorSet } = this.state;

        //  window.console.log(showStateIds, 'showStateIds');

        // 1、根据需求，在素材上显示文字和改变素材颜色
        if (Array.isArray(showStateIds)) {
            showStateIds.forEach((d) => {
                const { text, color } = d;
                const model = this.map.getModelByID(d.id);
                const ele = selectedEle.find(ele => ele.nodeId === d.id)
                // console.log('model', model)
                if (model && model.visible) {
                    if (!noName) {
                        model.setText(text);
                    }
                    // 没有选中按设定颜色显示
                    if (!ele && color) {
                        let fillColor = '';
                        // 20210616 新增设置素材状态颜色和透明度，objectColor如果不为空，并且以#开头，则为设置的素材颜色；不为空并且不已#开头，根据objectColor的内容去查找素材状态颜色；否则为默认颜色
                        if (color.startsWith('#')) {
                            fillColor = color;
                        } else if (color === 'free') {
                            fillColor = mapColorSet?.freeRgb || '#69E5A5';
                        } else if (color === 'busy') {
                            fillColor = mapColorSet?.busyRgb || '#FD7C7C';
                        } else if (color === 'disabled') {
                            fillColor = mapColorSet?.disabledRgb || '#D1D8DF';
                        }

                        model.setColor(fillColor);
                    }
                }
            });
        }
    };

    // 通过 markId 添加标记
    setMark = (markId = []) => {
        const { markUrl } = this.props
        // console.log('setMark', markId)
        if (!markUrl) {
            return
        }
        // 先清除已选中的图标
        this.removeImageMarker()
        // 再添加图标
        this.addImageMaker({
            url: markUrl,
            ids: markId,
        });
    }

    /* 在素材上添加图片标记
     ** url, 图片地址； id 素材 mapElementId
     */
    addImageMaker({ url, ids = [], markerScale = 1.5 }) {
        const { mapInfo } = this.state;
        this.map.markerScale = markerScale; //设置地图上标记缩放比例
        const layer = this.map.getMarkerLayer(mapInfo.cmapFloorId);
        const markers = [];
        if (layer && ids.length > 0) {
            ids.forEach((id) => {
                const model = this.map.getModelByID(id);
                const { x, y, z } = model && model.data.nodePosition;
                const marker = new window.GIM.ImageMarker(url, x, y, z);
                layer.add(marker);
                markers.push(marker);
            });
        }
        this.setState({ markers });
    }

    // 移除所有标记
    removeImageMarker() {
        const { markers = [] } = this.state;
        markers.forEach((m) => {
            m.dispose();
        });
    }

    // 将颜色色值 转换为数字
    colorToNum(color) {
        if (color.includes('#')) {
            const str = color.replace('#', '0x')
            return parseInt(str, 16)
        }
        return color
    }

    setStartEndPath = ({startPID = "298011", endPID = "297884", pathColor =  '#EA000A',  pathThickness = 18}) => {
        this.map.pathThickness = pathThickness; //路线的粗细
        this.map.pathColor = this.colorToNum(pathColor)
        this.map.startPID = startPID;
        this.map.endPID = endPID;
        // 规划路径
        setTimeout(() => {
            // 路径规划计算后的钩子函数
            this.map.searchPath((msg) => {
                // 规划路径计算信息
                // 路径规划成功
                if (msg.type === "done") {}
            });
        }, 500);
    }

    // 删除导引线
    clearPath = () => {
        // 清除标记
        this.map && this.map.cleanSelectUnit3D();
        // 清除路径
        this.map && this.map.clearPath(true);
    }

    startSimulateNav = () => {
        this.map && this.map.simulate()
        this.setState({ navState: 'doing' })
    }

    pauseSimulateNav = () => {
        const { navState } = this.state
        if (navState === 'doing') {
            // 暂停导航
            // console.log('暂停导航')
            this.map && this.map.toggleSimulate(false)
            this.setState({ navState: 'pause' })
        } else if (navState === 'pause') {
            // 继续导航
            this.map && this.map.toggleSimulate(true)
            this.setState({ navState: 'doing' })
        }
    }

    endSimulateNav = () => {
        const { endSimulateNav } = this.props
        // 清除标记
        this.map && this.map.cleanSelectUnit3D();
        // 清除路径
        this.map && this.map.clearPath(true);
        this.setState({ navState: 'init' })
        endSimulateNav()
    }

    render() {
        const { isLoading, mapElements, showToolTip, selectedEle } = this.state;
        const { componentWidth, componentHeight, tooltipContent, focusSelect, multiple,wapperId } = this.props;
        // if (mapElements && selectedEle.length == 0) {
        //   console.log('render showData', selectedEle)
        //   this.showData()
        // }
        // console.log('render', selectedEle)
        // console.log('render')
        return (
            <div
                style={{
                    width: componentWidth,
                    height: componentHeight,
                    position: "relative",
                }}
            >
                <div
                    id={wapperId}
                    style={{
                        width: componentWidth,
                        height: componentHeight,
                        visibility: isLoading ? "hidden" : "visible",
                    }}
                    onTouchStart={ (e) => {
                        // 针对 移动端
                        e.stopPropagation()
                        e.preventDefault();
                        this.setState({ showToolTip: false })
                    }}
                    onMouseDown={ (e) => {
                        // 针对 PC 端
                        e.stopPropagation()
                        e.preventDefault();
                        this.setState({ showToolTip: false })
                    }}
                ></div>
                {/* 单选模式，并启用了地图跟随点击位置居中，才显示 tooltip */}
                { !multiple && focusSelect && showToolTip && tooltipContent && selectedEle[0] &&
                tooltipContent(selectedEle[0].nodeId)
                }
            </div>
        );
    }
}

ChaunveMap.propTypes = {
    componentWidth: PropsTypes.number, // 组件宽度
    componentHeight: PropsTypes.number, // 组件高度
    accessToken: PropsTypes.string, // 验证的key
    themeID: PropsTypes.string, // 	对应的图标文件夹
    preCreation: PropsTypes.bool, // 是否在静默加载其他楼层地图
    labelViewModel: PropsTypes.string, // 区块文本的显示模式 auto为自动,none 为不显示，all全部显示
    labelScale: PropsTypes.number, // 文本的缩放比
    initFloorID: PropsTypes.string, // 最先初始化哪个楼层
    showLabelType: PropsTypes.string, // 显示label的类型 默认为编号，其他为绑定的信息
    enabledControl: PropsTypes.bool, // 是否启用手势操作
    opacity: PropsTypes.number, // 透明度
    isTextColorWrite: PropsTypes.bool, // 是否使用白色文字
    hideAreaTypes: PropsTypes.array, // 不需要显示的公共设施 AreaType Code 小写
    logoFiled: PropsTypes.string, // 公共设施图片接口字段
    interactiveTypes: PropsTypes.array, // 需要交互的区域类型 AreaType Code 小写
    background: PropsTypes.string, // 场景的背景色
    focusSelect: PropsTypes.bool, // 是否让点击区域居中
    isJavaServer: PropsTypes.bool, // 接口类型是java还是C#
    backgroundAlpha: PropsTypes.bool, // 背景是否透明
    facilityPanel: PropsTypes.bool, // 公共设施是否显示形状
    showLabelLength: PropsTypes.number, // 显示文字的半径
    showImageLength: PropsTypes.number, // 显示公共设施的半径
    lang: PropsTypes.string, // zh默认简体中文，en 英文，zh-hant，繁体中文
    showEdge: PropsTypes.bool, // 默认不启用描边
    showIDSDevice: PropsTypes.bool, // 是否显示ids点位
    loadMapGrid: PropsTypes.bool, // 是否加载地图网格以优化定位
    outRangeTimes: PropsTypes.number, // 定位跳出异常的次数
    locateLimitGrid: PropsTypes.number, // 定位能离上个定位点的格子
    edgeColor: PropsTypes.string, // 描边的颜色
    snapshotVersion: PropsTypes.string, // 快照版本
    signatureKey: PropsTypes.string, // 签名key
    restfulSignature: PropsTypes.bool, // 控制是否签名
    initCompleted: PropsTypes.func, // 地图加载完成
    onSelected: PropsTypes.func, // 当区块，或标注图片被选中的时候派发
    onClick: PropsTypes.func, // 当楼层被点击得时候激活
    onClickError: PropsTypes.func, // 不可点击事件回调
    onHover: PropsTypes.func, // 当鼠标悬停在区块时触发
    forceUpdate: PropsTypes.func, // 立即渲染更新地图
    multiple: PropsTypes.bool, // 多选模式，默认false
    defaultCenterPoint: PropsTypes.number, // 定位中心点
    zoomLevel: PropsTypes.number, //设置缩放级别 0-20
    maxCameraRadius: PropsTypes.number, //获取和设置相机的最大距离
    selectedColor: PropsTypes.string, // 获取和设置选中的颜色
    reloadMap: PropsTypes.bool, // 重新加载地图
    polarAngle: PropsTypes.number, //仰角数值
    reloadFinish: PropsTypes.func, // 重新加载地图完成回调
    reSetMap: PropsTypes.bool, // 重新渲染地图
    reSetMapFinish: PropsTypes.func, // 重新渲染地图完成回调
    selectableType: PropsTypes.string, // 批量操作类型
    clearSelectFlag: PropsTypes.bool, // 清除选中标记
    reSetClearFinish: PropsTypes.func, // 清除选中标记完成回调
    visibleElement: PropsTypes.array, // 可显示的元素id集合
    visibleType: PropsTypes.array, // 可显示的元素类型集合
    visibleState: PropsTypes.array, // 可显示的元素状态集合
    clickableElement: PropsTypes.array, // 可点击的元素id集合
    showStateIds: PropsTypes.array, // 显示不同元素的不同状态，数据结构：[{id: 1, state: 'XX', color: '#fff', text: ''}, {}]
    noName: PropsTypes.bool, // 不显示元素上名称
    endSimulateNav: PropsTypes.func, // 结束导航回调，需要重新显示导引线
    markId: PropsTypes.array, // 被查询或标记的元素id
    markUrl: PropsTypes.string, // 用户标记的资源地址
    mapSpaceJump: PropsTypes.bool, // 是否打开区域跳转开关
    reSetMapId: PropsTypes.string, // 绑定区域的素材对应区域的mapId
    defaultPath: PropsTypes.string, // 默认路径前缀
    wapperId: PropsTypes.string, // 包装容器的id
};

ChaunveMap.defaultProps = {
    componentWidth: DEFAULT_WIDTH,
    componentHeight: DEFAULT_HEIGHT,
    background: DEFAULT_BACKGROUND,
    initCompleted: () => {},
    onSelected: () => {},
    onClick: () => {},
    onClickError: () => {},
    onHover: () => {},
    forceUpdate: () => {},
    reloadFinish: () => {},
    reSetMapFinish: () => {},
    reSetClearFinish: () => {},
    signatureKey: null,
    restfulSignature: false,
    multiple: false,
    opacity: 1,
    themeID: "1003",
    preCreation: false, // 是否在静默加载其他楼层地图
    labelViewModel: "all", // 区块文本的显示模式 auto为自动,none 为不显示，all全部显示
    labelScale: 1.5, // 文本的缩放比
    initFloorID: null, // 最先初始化哪个楼层
    showLabelType: "No.", // 显示label的类型 默认为编号，其他为绑定的信息
    enabledControl: true, // 是否启用手势操作
    isTextColorWrite: false, // 是否使用白色文字
    hideAreaTypes: [], // 不需要显示的公共设施 AreaType Code 小写
    logoFiled: "DownLogo", // 公共设施图片接口字段
    interactiveTypes: [], // 需要交互的区域类型 AreaType Code 小写
    focusSelect: true, // 是否让点击区域居中
    isJavaServer: true, // 接口类型是java还是C#
    backgroundAlpha: false, // 背景是否透明
    facilityPanel: false, // 公共设施是否显示形状
    showLabelLength: 8000, // 显示文字的半径
    showImageLength: 8000, // 显示公共设施的半径
    lang: "zh", // zh默认简体中文，en 英文，zh-hant，繁体中文
    showEdge: false, // 默认不启用描边
    showIDSDevice: false, // 是否显示ids点位
    loadMapGrid: false, // 是否加载地图网格以优化定位
    outRangeTimes: 5, // 定位跳出异常的次数
    locateLimitGrid: 15, // 定位能离上个定位点的格子
    edgeColor: "#EA000A", // 描边的颜色
    snapshotVersion: "", // 快照版本
    defaultCenterPoint: 2200,
    zoomLevel: 10, //设置缩放级别
    maxCameraRadius: 8000,
    selectedColor: '#00ff00',
    reloadMap: false,
    polarAngle: 30,
    reSetMap: false,
    selectableType: "",
    clearSelectFlag: false,
    visibleElement: undefined,
    visibleType: undefined,
    visibleState: undefined,
    clickableElement: undefined,
    showStateIds: [],
    noName: false,
    endSimulateNav: () => {},
    markId: [],
    markUrl: '',
    mapSpaceJump: false,
    reSetMapId: ()=>{
    },
    defaultPath: 'vsk/', // 默认路径前缀
    wapperId: 'mapContainer', // 默认路径前缀
};

export default ChaunveMap;
